var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonAltcomponent = function SvgPersonAltcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 5.833a2.666 2.666 0 1 1-5.333 0 2.666 2.666 0 1 1 5.333 0Zm-8 6.667c0-1.774 3.553-2.667 5.333-2.667 1.78 0 5.334.893 5.334 2.667v1.333H2.666V12.5Z",
    fill: "current"
  })));
};
export default SvgPersonAltcomponent;